import { t } from '@/i18n'

import { formatCurrency } from '../fomatter.utils'
import { BODY_FONT } from '../text.utils'
import type { TicketElement } from '../TicketElement'
import type { TillMethod } from '../types'

export class TillBreakdown implements TicketElement {
  methods: Record<string, TillMethod>
  lineHeight: number
  separatorPadding: number
  topPadding: number
  totalExpectedEndAmount: number
  totalEndAmount: number

  constructor(methods: Record<string, TillMethod>) {
    this.methods = methods
    this.lineHeight = 22
    this.separatorPadding = 20
    this.topPadding = 30

    this.totalExpectedEndAmount = Object.values(methods).reduce((total, shift) => {
      total += shift.expectedEndAmount
      return total
    }, 0)

    this.totalEndAmount = Object.values(methods).reduce((total, shift) => {
      total += shift.endAmount
      return total
    }, 0)
  }

  height(): number {
    return (
      this.lineHeight * Object.keys(this.methods).length +
      this.lineHeight +
      this.separatorPadding +
      this.topPadding
    )
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    top += this.topPadding
    ctx.font = `bold 12px ${BODY_FONT}`
    ctx.fillStyle = 'black'
    ctx.textAlign = 'right'
    ctx.fillText(t('report.difference'), width, top)
    ctx.fillText(t('report.declared'), width * 0.75, top)
    ctx.fillText(t('report.calculated'), width * 0.5, top)
    Object.keys(this.methods).forEach(method => {
      top += this.lineHeight
      ctx.font = `12px ${BODY_FONT}`
      const difference = this.methods[method].endAmount - this.methods[method].expectedEndAmount
      ctx.textAlign = 'right'
      ctx.fillText(formatCurrency(difference), width, top)
      ctx.fillText(formatCurrency(this.methods[method].endAmount), width * 0.75, top)
      ctx.fillText(formatCurrency(this.methods[method].expectedEndAmount), width * 0.5, top)
      ctx.textAlign = 'left'
      ctx.font = `bold 12px ${BODY_FONT}`
      ctx.fillText(method.charAt(0).toUpperCase() + method.slice(1), 0, top)
    })
    ctx.fillStyle = 'black'
    ctx.font = `bold 12px ${BODY_FONT}`
    top += this.separatorPadding
    ctx.fillRect(0, top, width, 1)
    top += this.lineHeight
    ctx.fillText(t('report.total') + ':', 0, top)
    ctx.textAlign = 'right'
    ctx.fillText(formatCurrency(this.totalEndAmount - this.totalExpectedEndAmount), width, top)
    ctx.fillText(formatCurrency(this.totalEndAmount), width * 0.75, top)
    ctx.fillText(formatCurrency(this.totalExpectedEndAmount), width * 0.5, top)
  }
}
